// images
import blogImg1 from "../images/blog/img-1.jpg";
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/blog/img-3.jpg";

import blogSingleImg1 from "../images/blog-details/1.jpg";
import blogSingleImg2 from "../images/blog-details/2.jpg";
import blogSingleImg3 from "../images/blog-details/3.jpg";




const blogs = [
    {
        id: '1',
        title: 'Why Industry Are A Juicy Target For Cyberattack.',
        title2: 'Industrial Profits Grow Faster in First Eight Months.',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg1,
        link: 'READ MORE',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio corporis, libero,',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg1,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '2',
        title: 'Exploring The Wild Side in an Industrial Jungle.',
        title2: 'Industrial Profits Grow Faster.',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack2',
        screens: blogImg2,
        link: 'READ MORE',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio corporis, libero,',
        author: 'Linda Johns',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg2,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '3',
        title: 'EIndustrial Profits Grow Faster.',
        title2: ' Why Industry Are A Juicy Target For Cyberattack.',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack3',
        screens: blogImg3,
        link: 'READ MORE',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio corporis, libero,',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
 


];
export default blogs;



